import React from 'react';
import SectionHeader from '../SectionHeader/SectionHeader';
import AnswerShort from '../AnswerShort/AnswerShort';
import Icon from '../../../../components/Icon/Icon';
import {
  Container,
  ContentContainer,
  InfoMessage,
  InfoMessageContainer,
  InfoMessageContainerTopIcon,
  InfoIconContainer,
  BulletList,
  ValidationFailedMessageContainer,
} from './styles';
import {
  qRiskStatusInfoMessages,
  validationFailedTitle,
  validationFailedBulletPoints,
  QRiskProps,
  QRiskStatus,
} from '.';

function QRISK({ score10Year, scoreHealthy, heartAge, status, resultStatus }: QRiskProps) {
  const resolvedStatus: QRiskStatus =
    !status || status === 'not_calculated' ? 'qrisk_failed' : status;

  const infoMessage =
    resultStatus === 'time_exceeded'
      ? 'We have been unable to calculate your QRISK as the timer was exceeded.'
      : qRiskStatusInfoMessages.get(resolvedStatus);

  const showResults =
    resolvedStatus === 'success' ||
    resolvedStatus === 'pending' ||
    resolvedStatus === 'test_failed';

  const renderInfoMessage = () => {
    if (resolvedStatus === 'validation_failed') {
      return (
        <InfoMessageContainerTopIcon>
          <InfoIconContainer>
            <Icon name="info" size={24} />
          </InfoIconContainer>
          <ValidationFailedMessageContainer>
            <InfoMessage>{validationFailedTitle}</InfoMessage>
            <BulletList>
              {validationFailedBulletPoints.map((point) => (
                <li key={point}>
                  <InfoMessage>{point}</InfoMessage>
                </li>
              ))}
            </BulletList>
          </ValidationFailedMessageContainer>
        </InfoMessageContainerTopIcon>
      );
    }
    if (infoMessage) {
      return (
        <InfoMessageContainer>
          <InfoIconContainer>
            <Icon name="info" size={24} />
          </InfoIconContainer>
          <InfoMessage>{infoMessage}</InfoMessage>
        </InfoMessageContainer>
      );
    }
    return null;
  };

  return (
    <Container>
      <SectionHeader icon="qrisk" title="QRISK3" />
      <ContentContainer>
        {renderInfoMessage()}
        {showResults && (
          <>
            <InfoMessageContainer>
              <InfoIconContainer>
                <Icon name="info" size={24} />
              </InfoIconContainer>
              <InfoMessage>
                Some data used to calculate your QRISK score has been estimated. Please be aware
                that your QRISK score may be higher.
              </InfoMessage>
            </InfoMessageContainer>
            <AnswerShort label="Healthy Heart Age" value={heartAge ?? 'N/A'} />
            <AnswerShort
              label="10 Year Cardiovascular Risk"
              value={score10Year ? `${score10Year}%` : 'N/A'}
            />
            <AnswerShort
              label="Healthy Person Risk"
              value={scoreHealthy ? `${scoreHealthy}%` : 'N/A'}
            />
          </>
        )}
      </ContentContainer>
    </Container>
  );
}

export default QRISK;
